module.exports = __webpack_public_path__ + "img/06.f2c16207.png";